/* Pink Flow — interações das seções pf-*
   Sem bibliotecas de animação: o único movimento da loja é a marca d'água do hero, em CSS.
   Cada seção com comportamento declara data-pf-section="nome" e é iniciada por PF.sections[nome]. */
(() => {
  const PF = (window.PF = { sections: {} });

  /* ---------- Carrinho (Ajax + gaveta do Dawn) ---------- */
  const setLabel = (button, text) => {
    const label = button && button.querySelector('[data-label]');
    if (!label) return null;
    const old = label.textContent;
    label.textContent = text;
    return old;
  };

  PF.addToCart = async (variantId, button, quantity = 1) => {
    const drawer = document.querySelector('cart-drawer');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
    }
    try {
      const body = { items: [{ id: Number(variantId), quantity }] };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erro ao adicionar');
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location = window.routes.cart_url;
        return;
      }
      const old = setLabel(button, 'Adicionado');
      button?.classList.add('is-added');
      setTimeout(() => {
        if (old) setLabel(button, old);
        button?.classList.remove('is-added');
      }, 2200);
      PF.refreshCartCount();
    } catch (err) {
      console.error('[PinkFlow]', err);
      setLabel(button, 'Indisponível');
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
      }
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pf-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    PF.addToCart(btn.dataset.pfAdd, btn);
  });

  /* ---------- Barra de abas do celular (estilo app) ---------- */
  PF.refreshCartCount = async () => {
    const badge = document.querySelector('[data-pf-cart-count]');
    if (!badge) return;
    try {
      const cart = await (await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    } catch (err) {
      console.error('[PinkFlow]', err);
    }
  };

  const tabActions = {
    menu: () => document.querySelector('header-drawer summary')?.click(),
    cart: () => {
      const link = document.getElementById('cart-icon-bubble');
      if (link) link.click();
      else window.location = window.routes.cart_url;
    },
  };
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-pf-tab]');
    if (!tab) return;
    e.preventDefault();
    tabActions[tab.dataset.pfTab]?.();
  });
  if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => PF.refreshCartCount());

  /* ---------- Quiz "Qual é o seu ritual?" ---------- */
  PF.sections.quiz = (section) => {
    const steps = [...section.querySelectorAll('.pf-quiz__step')];
    const results = [...section.querySelectorAll('.pf-quiz__result')];
    const progress = section.querySelector('.pf-quiz__progress span');
    const answers = {};
    let current = 0;

    const setProgress = (value) => {
      if (progress) progress.style.transform = `scaleX(${value})`;
    };

    const show = (idx, focus) => {
      steps.forEach((s, i) => (s.hidden = i !== idx));
      setProgress((idx + 1) / (steps.length + 1));
      current = idx;
      if (focus) steps[idx].querySelector('.pf-quiz__opt')?.focus();
    };

    const finish = () => {
      let key = answers.need || 'completo';
      if (answers.time === 'completa' && key !== 'antifrizz') key = 'completo';
      if (answers.heat === 'sim' && key === 'hidratacao') key = 'brilho';
      steps.forEach((s) => (s.hidden = true));
      const result = results.find((r) => r.dataset.key === key) || results[0];
      results.forEach((r) => (r.hidden = r !== result));
      setProgress(1);
      result?.querySelector('a, button')?.focus();
    };

    section.addEventListener('click', (e) => {
      const opt = e.target.closest('.pf-quiz__opt');
      if (opt) {
        answers[opt.dataset.q] = opt.dataset.a;
        opt.parentElement.querySelectorAll('.pf-quiz__opt').forEach((o) => o.setAttribute('aria-pressed', String(o === opt)));
        setTimeout(() => (current + 1 < steps.length ? show(current + 1, true) : finish()), 200);
      }
      if (e.target.closest('[data-quiz-restart]')) {
        Object.keys(answers).forEach((k) => delete answers[k]);
        results.forEach((r) => (r.hidden = true));
        section.querySelectorAll('.pf-quiz__opt').forEach((o) => o.setAttribute('aria-pressed', 'false'));
        show(0, true);
      }
    });
    show(0, false);
  };

  /* ---------- Barra fixa de compra na página de produto ---------- */
  PF.sections['sticky-atc'] = (section) => {
    const bar = section.querySelector('.pf-satc');
    const mainBtn = document.querySelector('product-form .product-form__submit');
    if (!bar || !mainBtn) return;
    new IntersectionObserver(([entry]) => {
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(mainBtn);
    bar.querySelector('[data-satc-buy]')?.addEventListener('click', () => mainBtn.click());
  };

  /* ---------- Início ---------- */
  function initScope(scope) {
    scope.querySelectorAll('[data-pf-section]').forEach((s) => {
      if (s.dataset.pfInit) return;
      s.dataset.pfInit = '1';
      const fn = PF.sections[s.dataset.pfSection];
      try {
        if (fn) fn(s);
      } catch (err) {
        console.error('[PinkFlow]', s.dataset.pfSection, err);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initScope(document));
  else initScope(document);

  // Editor de temas da Shopify
  document.addEventListener('shopify:section:load', (e) => initScope(e.target));
})();
